module.exports = __webpack_public_path__ + "static/media/fortlev-solar-usina-02.552a98db.jpg";